import React from "react";
import PropTypes from "prop-types";

import { Badge } from "react-bootstrap";
// import Accordion from "react-bootstrap/Accordion";

import {
  AccordionCardHeader,
  AccordionTitle,
  AccordionChevron,
  AccordionStatus,
} from "./AccordionStyles.js";
import { Chevron } from "../Chevron/index.js";

const AccordionHeader = ({ isOpen, title, icon: Icon }) => (
  <AccordionCardHeader>
    <AccordionChevron>
      <Chevron isOpen={isOpen} />
    </AccordionChevron>
    <AccordionTitle>{title}</AccordionTitle>
    {Icon && <AccordionStatus>{Icon}</AccordionStatus>}
  </AccordionCardHeader>
);
AccordionHeader.propTypes = {
  as: PropTypes.oneOf([Badge]),
  eventKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  icon: PropTypes.node,
  variant: PropTypes.string,
};
AccordionHeader.defaultProps = {
  as: Badge,
  variant: "light",
  title: "",
  icon: null,
};

export default AccordionHeader;
